import { axiosWithAuth } from "helpers";

export const preAppService = {
	sendPreApp,
	getPreAppLink,
};

const API_URL = process.env.REACT_APP_API_URL;

function sendPreApp(model) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/send-pre-app`,
		data: model,
	};

	return axiosWithAuth(options);
}

function getPreAppLink(agentId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/agents/${agentId}/pre-app/link`,
	};

	return axiosWithAuth(options);
}
